module.exports = __webpack_public_path__ + "img/pattern_how1.0533c733.svg";